import {Box} from "@mui/material";
import {SurveyReviewState} from "crqlar-react-common/dist/models/survey/surveySubmission.model";
import React from "react";
import {useTranslation} from "react-i18next";
import {ElementChip} from "./base/ElementChip";
import {getSurveyReviewStateColor} from "./colors";

export const SURVEY_REVIEW_STATE_LABEL_KEYS: Record<SurveyReviewState, string> = {
    [SurveyReviewState.OPEN]: 'Review state OPEN',
    [SurveyReviewState.REVIEWED]: 'Review state REVIEWED',
};

interface SurveyReviewStateElementProps {
    reviewState: SurveyReviewState | undefined;
    asPrint?: boolean;
}

export function SurveyReviewStateElement({reviewState, asPrint = false}: SurveyReviewStateElementProps) {
    const {t} = useTranslation();

    const effectiveState = reviewState ?? SurveyReviewState.OPEN;
    const text = t(SURVEY_REVIEW_STATE_LABEL_KEYS[effectiveState] ?? effectiveState);

    if (asPrint) {
        return <>{text}</>;
    }

    return (
        <Box sx={{display: "inline-flex", maxWidth: "100%"}}>
            <ElementChip
                text={text}
                startIcon={
                    <Box
                        component="span"
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            bgcolor: getSurveyReviewStateColor(effectiveState),
                            flex: "0 0 auto",
                        }}
                    />
                }
            />
        </Box>
    );
}
